// @ts-ignore
/* eslint-disable */

export type ApiCodeResponse<T = any> = {
  code: number;
  msg: string;
  data?: T;
};

export function ensureCodeOk<T>(res: ApiCodeResponse<T>): ApiCodeResponse<T> {
  if (!res || typeof (res as any).code !== 'number') return res;
  if (res.code !== 200) {
    const err: any = new Error(res.msg || '请求失败');
    err.code = res.code;
    err.data = res;
    throw err;
  }
  return res;
}

export function ensureCodeSuccess<T>(
  res: ApiCodeResponse<T>,
  successCodes: number[] = [0, 200],
): ApiCodeResponse<T> {
  if (!res || typeof (res as any).code !== 'number') return res;
  if (!successCodes.includes(res.code)) {
    const err: any = new Error((res as any).msg || (res as any).message || '请求失败');
    err.code = res.code;
    err.data = res;
    throw err;
  }
  return res;
}

export function getBackendErrorMessage(e: any): string {
  const raw = e?.response?.data;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.msg) return parsed.msg;
      if (parsed?.message) return parsed.message;
    } catch (_err) {
      // ignore
    }
  }
  return (
    e?.response?.data?.msg ||
    e?.response?.data?.message ||
    e?.data?.msg ||
    e?.data?.message ||
    e?.message ||
    '请求失败，请稍后重试'
  );
}

